import { render, staticRenderFns } from "./mappingList.vue?vue&type=template&id=6bf5b587&scoped=true"
import script from "./mappingList.vue?vue&type=script&lang=js"
export * from "./mappingList.vue?vue&type=script&lang=js"
import style0 from "./mappingList.vue?vue&type=style&index=0&id=6bf5b587&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf5b587",
  null
  
)

export default component.exports